/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };

export { isNumericalString };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/is-numerical-string.mjs
// module id = PsbC
// module chunks = 0